// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.version-footer {
    margin: 0.5rem 0 0;
    text-align: center;
    font-size: 0.7rem;
    color: var(--light-grey-color);
}
`, "",{"version":3,"sources":["webpack://./src/components/VersionFooter.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,8BAA8B;AAClC","sourcesContent":[".version-footer {\n    margin: 0.5rem 0 0;\n    text-align: center;\n    font-size: 0.7rem;\n    color: var(--light-grey-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
